import React, { useState } from "react";
import Sidebar from "./Sidebar";

export default function Dashboard({ onLogout, children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="d-flex dashboard-wrapper ">
      <Sidebar onLogout={onLogout} isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="main-content
       
        flex-grow-1 p-lg-4 ">
        {children}
      </div>
    </div>
  );
}
